import cx from 'classnames'
import type { ReactElement, ReactNode } from 'react'

import type { BadgeSlotClasses } from 'src/components/BadgeSlot'

type BuildParams = {
  exclusiveTag: boolean
  showNew: boolean
  showTop: boolean
  hasJackpotTicker: boolean
  jackpotElement: ReactNode
  classes: BadgeSlotClasses
}

function renderTag(label: string, tagItem: string, specific: string, key?: string): ReactElement {
  return (
    <span key={key} className={cx(tagItem, specific)}>
      {label}
    </span>
  )
}

export function buildGameBadges({
  exclusiveTag,
  showNew,
  showTop,
  hasJackpotTicker,
  jackpotElement,
  classes,
}: BuildParams): { staticExclusiveItem: ReactElement | null; animatedBadges: ReactNode[] } {
  const showExclusiveStatic = exclusiveTag && (showNew || showTop) && !hasJackpotTicker
  const allowNewTop = !(exclusiveTag && hasJackpotTicker)

  const staticExclusiveItem = showExclusiveStatic ? renderTag('EXCLUSIVE', classes.tagItem, classes.tagExclusive) : null

  const animatedBadges: ReactNode[] = showExclusiveStatic
    ? []
    : ([
        hasJackpotTicker && jackpotElement,
        exclusiveTag && renderTag('EXCLUSIVE', classes.tagItem, classes.tagExclusive, 'exclusive'),
        allowNewTop && showNew && renderTag('NEW', classes.tagItem, classes.tagNew, 'new'),
        allowNewTop && showTop && renderTag('TOP', classes.tagItem, classes.tagTop, 'top'),
      ].filter(Boolean) as ReactNode[])

  return { staticExclusiveItem, animatedBadges }
}
